<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Nuevo Pedido</h4>
            </div>
         </div>
      </div>
      <div v-if="!albaran" class="row">
         <div class="col-xl-12">
            <div class="card">
               <div class="card-body">
                  <form-wizard color="#000">
                     <tab-content icon="mdi mdi-account-circle">
                        <h4 class="card-title mb-4">Datos del Cliente</h4>
                        <div class="row">
                           <div class="col-12">
                              <div class="form-group row mb-3">
                                 <label class="col-md-2 col-form-label" for="userName">Empresa</label>
                                 <div class="col-md-10">
                                    <multiselect v-model="empresa" :options="customersByZone" :placeholder="'Seleccionar cliente'" :selectLabel="'Pulse encima para seleccionar'" :deselectLabel="'Pulse encima para deseleccionar'" :selectedLabel="'Seleccionado'"></multiselect>
                                 </div>
                              </div>
                              <div class="form-group row mb-3">
                                 <label class="col-md-2 col-form-label" for="password">Punto de Venta</label>
                                 <div class="col-md-10">
                                    <select v-model="pv" :disabled="pvDisable" class="form-control">
                                       <option v-for="(pv, index) in pvByClient" :key="index" :value="index">{{ pv.nombrePV}} - {{ pv.direPV }} {{pv.pobPV}} ({{pv.cpPV}})</option>
                                    </select>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </tab-content>
                     <tab-content icon="mdi mdi-face-profile">
                        <h4 class="card-title mb-4">Datos del Pedido</h4>
                        <div class="row">
                           <div class="col-md-2 col-xl-2">
                              <div class="form-group">
                                 <label>Referencia</label>
                                 <input v-model="ref" @blur="buscarRef()" type="text" class="form-control" />
                              </div>
                           </div>
                           <div class="col-md-2 col-xl-1">
                              <div class="form-group">
                                 <label>Unidades</label>
                                 <input v-model="unidades" type="number" class="form-control" />
                              </div>
                           </div>
                           <div class="col-md-2 col-xl-1">
                              <div class="form-group">
                                 <label>PVP</label>
                                 <input v-model="pvp" type="text" class="form-control" @change="cambioPVP" /> 
                              </div>
                           </div>
                           <div class="col-md-2 col-xl-1">
                              <div class="form-group">
                                 <label>Descuento</label>
                                 <input v-model="descuento" type="number" min="0" max="100" class="form-control" /> 
                              </div>
                           </div>
                           <div class="col-md-6 col-xl-3">
                              <div class="form-group">
                                 <label>Descripción</label>
                                 <input v-model="desc" type="text" class="form-control" readonly />
                              </div>
                           </div>
                           <div class="col-md-2 col-xl-1">
                              <div class="form-group">
                                 <label style="color: #fff;">Añadir</label>
                                 <button @click="addItem" :disabled="unidades < 1" type="button" class="btn btn-danger">Añadir</button>
                              </div>
                           </div>
                            <div class="col-md-4 col-xl-2">
                              <div class="form-group">
                                 <label>Suma Pedido</label>
                                 <p style="font-size: 22px;">{{ sumaTotal | currency }}</p>
                              </div>
                           </div>
                           <order-summary :items="items" :sumaTotal="sumaTotal" v-on:ajusteSumaTotal="ajusteSumaTotal" v-on:ajusteUnidades="ajusteUnidades"></order-summary>
                        </div>
                     </tab-content>
                     <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                        <div class="row justify-content-md-center">
                           <div class="col-6">
                              <div class="text-center">
                                 <h2 class="mt-0"><i class="mdi mdi-check-all"></i></h2>
                                 <h3 class="mt-0">Confirmar Envío</h3>

                                 <p class="w-75 mb-2 mx-auto">
                                    ¿Está seguro que desea enviar el pedido?
                                 </p>

                                 <div class="mt-4">
                                    <div class="custom-control custom-checkbox">
                                       <input v-model="envioCC" id="customCheck1" type="checkbox" class="custom-control-input" />
                                       <label class="custom-control-label" for="customCheck1"> Enviar copia al cliente</label>
                                    </div>
                                 </div>

                                 <b-form-group v-if="envioCC" class="mt-2" label-cols-sm="3" label-cols-lg="3" label="Enviar copia a:">
                                    <b-form-input v-model="customerEmail" for="text"></b-form-input>
                                 </b-form-group>

                                 <div class="my-3">
                                    <div>
                                       <textarea v-model="observaciones" class="form-control" :maxlength="225" rows="3" placeholder="Observaciones"></textarea>
                                       <div class="text-center mt-1">
                                          El campo Observaciones sólo será visible por ASEIN.<br>
                                          <p v-if="observaciones" class="badge position-absolute" :class="{ 'badge-success': observaciones.length !== 225, 'badge-danger': observaciones.length === 225 }">
                                             {{ observaciones.length }} /
                                             225
                                          </p>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </tab-content>

                     <button slot="prev" type="button" class="btn btn-danger">Anterior</button>
                     <button slot="next" type="button" class="btn btn-danger" :disabled="nextDisable">Siguiente</button>
                     <button @click="sendOrder" :disabled="btnEnviarDeshabilitado" slot="finish" type="button" class="btn btn-danger">Enviar <b-spinner v-if="loading" small></b-spinner></button>

                     </form-wizard>
               </div>
            </div>
         </div>
      </div>

      <div v-else>
         <albaran :order="order"></albaran>
      </div>
   </Layout>
</template>

<script>
   import Layout from '@/layouts/Main'
   import OrderSummary from '@/components/widgets/orders/orderSummary'
   import Albaran from '@/components/albaran.vue'
   import { FormWizard, TabContent } from 'vue-form-wizard'
   import Multiselect from 'vue-multiselect'
   import axios from 'axios'

   export default {
      name: 'NewOrder',
      data () {
         return {
            customers: [],
            puntosVentas: [],
            empresa: null,
            pv: null,
            ref: null,
            codart: null,
            unidades: null,
            desc: null,
            pvp: 0,
            pvpCambiado: false,
            descuento: '48',
            envioCC: false,
            items: [],
            sumaTotal: 0,
            customerEmail: '',
            observaciones: '',
            albaran: false,
            order: '',
            codcli: '',
            coddep: '',
            pvNombre: '',
            puntoVentaDire: '',
            puntoVentaPoblac: '',
            puntoVentaCP: '',
            loading: false,
            btnEnviarDeshabilitado: false
         }
      },
      computed: {
         customersByZone () {
            let temp = this.customers.filter(cliente => cliente.repre == this.$store.state.user.selectedZone)
            let temp2 = []
            const myObj = []
            temp.forEach(element => temp2.push('[' + element.codcli.substr(3).trim() + '] ' + element.empresa))
            temp = temp2
            temp2 = []
            temp.forEach(el => !(el in myObj) && (myObj[el] = true) && temp2.push(el))
            return temp2
         },
         pvDisable () {
            if (this.empresa == null) {
               return true
            } else {
               //eslint-disable-next-line
               this.empresa = this.empresa.substr(this.empresa.indexOf("]") + 2)
               return false
            }
         },
         pvByClient () {
            let temp = this.customers.filter(cliente => cliente.repre == this.$store.state.user.selectedZone)
            temp = temp.filter(cliente => cliente.empresa == this.empresa)
            temp.forEach(element => this.codcli = element.codcli)
            let temp2 = []
            temp.forEach(element => temp2.push({ coddep: element.coddep, nombrePV: element.nombrePV, direPV: element.direPV, pobPV: element.pobPV, cpPV: element.cpPV }))
            this.eliminarPV()
            return temp2
         },
         nextDisable() {
            if (this.pv == null) {
               return true
            } else {
               //eslint-disable-next-line
               this.coddep = this.pvByClient[this.pv].coddep
               //eslint-disable-next-line
               this.puntoVentaDire = this.pvByClient[this.pv].direPV
               //eslint-disable-next-line
               this.puntoVentaPoblac = this.pvByClient[this.pv].pobPV
               //eslint-disable-next-line
               this.puntoVentaCP = this.pvByClient[this.pv].cpPV
               //eslint-disable-next-line
               this.pvNombre = this.pvByClient[this.pv].nombrePV
               return false
            }
         }
      },
      methods: {
         eliminarPV () {
            this.pv = null
         },
         async buscarRef () {
            let params = "json="+JSON.stringify({ 'ref': this.ref })

            await axios({url: 'https://portal.asein.es/api-v2/widget-buscar-ref', data: params, method: 'POST' })
            .then(resp => {
               this.desc = resp.data['desc']
               this.pvp = resp.data['pvp'].replace('.', ',')
               this.codart = resp.data['codart']
            })
            .catch(err => {
               console.log(err)
            })
         },
         addItem () {
            if (this.descuento == '') {
               this.descuento = 0
            }
            this.items.push({'codart': this.codart, 'ref': this.ref, 'uni': this.unidades, 'descr': this.desc, 'pvp': this.pvp.replace(',', '.'), 'pvpCambiado': this.pvpCambiado, 'descuento': this.descuento, 'pvpTotal': this.pvp.replace(',', '.') * (1 - this.descuento / 100) * this.unidades })
 
            this.sumaTotal = this.sumaTotal + (this.pvp.replace(',', '.') * (1 - this.descuento / 100) * this.unidades)

            function ordenar(a, b) {
               if (a.codart < b.codart) {
                  return -1
               }
               if (a.codart > b.codart) {
                  return 1
               }
               return 0
            }

            this.items.sort(ordenar)
         
            this.codart = null,
            this.ref = null,
            this.unidades = null,
            this.desc = null
            this.pvp = 0
            this.pvpCambiado = false
            this.descuento = '48'
         },
         ajusteSumaTotal (e) {
            this.sumaTotal = this.sumaTotal - e
         },
         ajusteUnidades () {
            this.sumaTotal = 0
            for (const item of this.items) {
               this.sumaTotal = this.sumaTotal + item.pvpTotal
            }
         },
         async sendOrder () {
            this.btnEnviarDeshabilitado = true
            this.loading = true
            this.order = { id: '', fecha: new Date(), nombre: this.$store.state.user.fullname, repre: this.$store.state.user.selectedZone, email: this.$store.state.user.email, codcli: this.codcli, coddep: this.coddep, puntoVentaDire: this.puntoVentaDire, puntoVentaPoblac: this.puntoVentaPoblac, puntoVentaCP: this.puntoVentaCP, empresa: this.empresa, pv: this.pvNombre, items: this.items, envioCC: this.envioCC, customerEmail: this.customerEmail, observaciones: this.observaciones, sumaTotal: this.sumaTotal }
            let params = "json="+JSON.stringify({ 'pedido': this.order })
            params = params.replace(/&/g, "and")

            await axios({url: 'https://portal.asein.es/api-v2/enviar-pedido', data: params, method: 'POST' })
            .then(resp => {
               this.order['id'] = resp.data
               this.loading = false
            })
            .catch(err => {
               console.log(err)
            })
            this.albaran = true
         },
         cambioPVP () {
            this.pvpCambiado = true
         }
      },
      components: {
         Layout, FormWizard, TabContent, Multiselect, OrderSummary, Albaran
      },
      async mounted () {
         let zonas = this.$store.state.user.zones
         let params = "json="+JSON.stringify({ 'zonas': zonas })
          
         await axios({url: 'https://portal.asein.es/api-v2/widget-nuevo-pedido', data: params, method: 'POST' })
         .then(resp => {
            this.customers = resp.data
         })
         .catch(err => {
            console.log(err)
         })
      }
   }
</script>

<style>
   i.wizard-icon.mdi {
      color: #000;
   }
</style>